// extracted by mini-css-extract-plugin
export default {"homeWorksGroup":"HomeWorks_homeWorksGroup__wMwLa","empty":"HomeWorks_empty__NC9qV"};